import { useState, useCallback } from 'react';
import { Screen } from '../types';

export const useScreenNavigation = (screens: Screen[]) => {
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const currentScreen = screens[currentScreenIndex];
  const canGoBack = currentScreenIndex > 0;
  const canGoNext = currentScreenIndex < screens.length - 1;

  const goToNext = useCallback(async () => {
    if (!canGoNext) return;
    
    setIsLoading(true);
    
    // Simulate processing delay for certain screens
    if (currentScreen.type === 'onboarding') {
      await new Promise(resolve => setTimeout(resolve, 1500));
    }
    
    setCurrentScreenIndex(prev => prev + 1);
    setIsLoading(false);
  }, [canGoNext, currentScreen.type]);

  const goToPrevious = useCallback(() => {
    if (!canGoBack) return;
    setCurrentScreenIndex(prev => prev - 1);
  }, [canGoBack]);

  const goToScreen = useCallback((screenId: string) => {
    const index = screens.findIndex(screen => screen.id === screenId);
    if (index !== -1) {
      setCurrentScreenIndex(index);
    }
  }, [screens]);

  return {
    currentScreen,
    currentScreenIndex,
    canGoBack,
    canGoNext,
    isLoading,
    goToNext,
    goToPrevious,
    goToScreen
  };
};
